export const getFileRenameRulesList = (store) => store?.fileRenameRules?.list;
export const getSelectedFileRenameRule = (store) => store?.fileRenameRules?.selectedRule;
export const getFileRenamePlaceholders = (store) => store?.fileRenameRules?.placeholders || [];
export const getFileRenameDocumentTypes = (store) => store?.fileRenameRules?.documentTypes || [];
export const getFileRenameLenders = (store) => store?.fileRenameRules?.lenders || [];
export const getFileRenameRulesPage = (store) => store?.fileRenameRules?.page || 0;
export const getFileRenameRulesFilter = (store) =>
  store?.fileRenameRules?.filter || {
    search: "",
    order: "asc",
    orderBy: "name",
    documentTypes: [],
  };
